import { useTranslation } from "react-i18next";

const technologies = [
  {
    id: "01",
    icon: "ri-sun-fill",
    titleKey: "tech1_title",
    descKey: "tech1_desc",
    specs: ["tech1_s1", "tech1_s2", "tech1_s3"],
    image: "https://public.readdy.ai/ai/img_res/b0c0483a92b92b2e93572af9bf5dd465.jpg",
  },
  {
    id: "02",
    icon: "ri-route-line",
    titleKey: "tech2_title",
    descKey: "tech2_desc",
    specs: ["tech2_s1", "tech2_s2", "tech2_s3"],
    image: "https://readdy.ai/api/search-image?query=futuristic%20space%20station%20and%20spacecraft%20docking%20in%20orbit%2C%20cislunar%20logistics%20hub%2C%20multiple%20spacecraft%20approaching%2C%20earth%20visible%20in%20background%2C%20cinematic%20space%20photography%20style%2C%20photorealistic%20CGI%2C%20dramatic%20lighting%2C%20deep%20black%20space%20with%20stars&width=800&height=500&seq=tech002&orientation=landscape",
  },
  {
    id: "03",
    icon: "ri-home-gear-line",
    titleKey: "tech3_title",
    descKey: "tech3_desc",
    specs: ["tech3_s1", "tech3_s2", "tech3_s3"],
    image: "https://readdy.ai/api/search-image?query=futuristic%20lunar%20base%20colony%20on%20moon%20surface%20with%20pressurized%20habitat%20modules%2C%20solar%20panels%2C%20communication%20towers%2C%20astronauts%20in%20spacesuits%2C%20earth%20in%20dark%20sky%2C%20cinematic%20NASA%20concept%20art%2C%20photorealistic%20render%2C%20dramatic%20golden%20sunlight&width=800&height=500&seq=tech003&orientation=landscape",
  },
  {
    id: "04",
    icon: "ri-exchange-dollar-line",
    titleKey: "tech4_title",
    descKey: "tech4_desc",
    specs: ["tech4_s1", "tech4_s2", "tech4_s3"],
    image: "https://readdy.ai/api/search-image?query=abstract%20futuristic%20digital%20network%20visualization%20in%20space%2C%20glowing%20nodes%20and%20connections%20representing%20space%20economy%2C%20dark%20background%20with%20stars%2C%20golden%20and%20orange%20light%20trails%2C%20cinematic%20sci-fi%20concept%20art%2C%20ultra%20detailed%2C%20photorealistic%20render&width=800&height=500&seq=tech004&orientation=landscape",
  },
];

export default function TechnologySection() {
  const { t } = useTranslation();

  return (
    <section id="technology" className="relative py-16 md:py-32 bg-[#070b14]">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 80% 50%, rgba(255,140,0,0.3) 0%, transparent 50%)" }} />
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
            <span className="text-amber-400 text-[10px] md:text-xs tracking-[0.3em] uppercase" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("tech_badge")}</span>
            <div className="w-6 md:w-8 h-px bg-amber-400/60" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white mb-3 md:mb-4" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t("tech_title")}</h2>
          <p className="text-white/40 text-xs md:text-sm max-w-xl mx-auto">{t("tech_subtitle")}</p>
        </div>

        <div className="space-y-4 md:space-y-6">
          {technologies.map((tech, index) => (
            <div
              key={tech.id}
              className={`group flex flex-col ${index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"} gap-0 border border-white/10 rounded-lg overflow-hidden hover:border-amber-400/30 transition-all duration-500`}
            >
              <div className="relative lg:w-1/2 h-44 md:h-56 lg:h-auto overflow-hidden">
                <img src={tech.image} alt={t(tech.titleKey)} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                <div className={`absolute inset-0 bg-gradient-to-${index % 2 === 0 ? "r" : "l"} from-transparent to-[#070b14]/80`} />
                <div className="absolute bottom-3 left-3 md:bottom-4 md:left-4 text-4xl md:text-6xl font-black text-white/10" style={{ fontFamily: "'Orbitron', sans-serif" }}>{tech.id}</div>
              </div>
              <div className="lg:w-1/2 p-5 md:p-8 lg:p-10 flex flex-col justify-center bg-white/[0.02]">
                <div className="flex items-center gap-3 mb-3 md:mb-4">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-amber-400/10 border border-amber-400/20 flex-shrink-0">
                    <i className={`${tech.icon} text-amber-400 text-sm md:text-base`} />
                  </div>
                  <h3 className="text-white font-bold text-sm md:text-lg" style={{ fontFamily: "'Orbitron', sans-serif" }}>{t(tech.titleKey)}</h3>
                </div>
                <p className="text-white/50 text-xs md:text-sm leading-relaxed mb-4 md:mb-6">{t(tech.descKey)}</p>
                <div className="flex flex-wrap gap-1.5 md:gap-2">
                  {tech.specs.map((sk) => (
                    <span key={sk} className="px-2 md:px-3 py-0.5 md:py-1 text-[10px] md:text-xs border border-amber-400/20 text-amber-400/70 rounded-full bg-amber-400/5">{t(sk)}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
